export type CatalogSnapshot = { types: string; skus: string };

function productTypeSignature(types: Array<{ name: string }> | undefined): string {
  return JSON.stringify([...(types ?? []).map((item) => item.name)].sort());
}

function skuSignature(skus: Array<{ name: string; isFocused: boolean }> | undefined): string {
  return JSON.stringify(
    [...(skus ?? []).map((item) => `${item.name}:${item.isFocused ? "1" : "0"}`)].sort(),
  );
}

export function catalogSnapshot(
  types: Array<{ name: string }> | undefined,
  skus: Array<{ name: string; isFocused: boolean }> | undefined,
): CatalogSnapshot {
  return { types: productTypeSignature(types), skus: skuSignature(skus) };
}

/** True only when both catalogs moved. Tenant sync writes SKUs first, then types. */
export function bothCatalogsUpdated(current: CatalogSnapshot, snapshot: CatalogSnapshot): boolean {
  return current.types !== snapshot.types && current.skus !== snapshot.skus;
}
